import React, { useCallback, useEffect, useState } from 'react'
import './styles.scss'

const DeleteItem: React.FC = () => {
  return <div className="delete_container"></div>
}

export default DeleteItem
